<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <header class="header navbar navbar-expand-sm">
                <ul class="navbar-item theme-brand flex-row text-center">
                    <li class="nav-item theme-logo">
                        <router-link to="/">
                            <img src="/src/assets/images/logo-mini.png" class="navbar-logo" alt="logo" style="width: 52px; height: 36px;" />
                        </router-link>
                    </li>
                    <li class="nav-item theme-text">
                        <router-link to="/" class="nav-link" style="font-size: 1em !important;
                        text-align: left;"> 
                            Descomplique sua correção
                        </router-link>
                    </li>
                </ul>
                <a v-if="!isHorizontal" href="javascript:void(0);" class="sidebarCollapse header-nav-toggle" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>
                <nav class="header-nav-links">
                    <router-link to="/" class="header-nav-link">Início</router-link>
                    <router-link v-if="isAuthenticated" to="/cursos" class="header-nav-link">Meus cursos</router-link>
                </nav>
                <div class="navbar-item flex-row ms-md-auto">
                    <!-- PLANOS - COMENTADO TEMPORARIAMENTE (pode ser reativado no futuro) -->
                    <!--
                    <a href="/plano" class="badge badge-warning badge-chip badge-custom ms-2 position-relative">
                        <span class="text"> {{ $store.state.auth?.user?.active_subscription?.plan?.name || 'Plano Básico' }} </span>
                    </a>
                    -->
                    <div class="dark-mode d-flex align-items-center">
                        <a v-if="$store.state.dark_mode == 'light'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('dark')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-sun"
                            >
                                <circle cx="12" cy="12" r="5"></circle>
                                <line x1="12" y1="1" x2="12" y2="3"></line>
                                <line x1="12" y1="21" x2="12" y2="23"></line>
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                <line x1="1" y1="12" x2="3" y2="12"></line>
                                <line x1="21" y1="12" x2="23" y2="12"></line>
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                            </svg>
                            <span class="ms-2"></span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'dark'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('system')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-moon"
                            >
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                            </svg>
                            <span class="ms-2"></span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'system'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('light')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-airplay"
                            >
                                <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                <polygon points="12 15 17 21 7 21 12 15"></polygon>
                            </svg>
                            <span class="ms-2"></span>
                        </a>
                    </div>

                    <!-- NOTIFICAÇÕES - COMENTADO TEMPORARIAMENTE (pode ser reativado no futuro) -->
                    <!--
                    <div class="dropdown nav-item notification-dropdown btn-group">
                        <a href="javascript:;" id="ddlnotify" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only nav-link notification-bell" @click="handleNotificationClick">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-bell"
                            >
                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                            </svg>
                            <span 
                                v-if="notificacoesStore.unreadCount > 0" 
                                class="notification-badge"
                                :class="{ 
                                    'notification-badge-large': notificacoesStore.unreadCount > 9 && notificacoesStore.unreadCount <= 99,
                                    'notification-badge-extra-large': notificacoesStore.unreadCount > 99
                                }"
                            >
                                {{ notificacoesStore.unreadCount > 99 ? '99+' : notificacoesStore.unreadCount }}
                            </span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right notification-dropdown-menu" aria-labelledby="ddlnotify">
                            <li class="notification-header" role="presentation">
                                <div class="d-flex align-items-center justify-content-between px-3 py-2">
                                    <h6 class="mb-0 fw-bold">Notificações</h6>
                                    <span v-if="notificacoesStore.unreadCount > 0" class="notification-count-badge">
                                        {{ notificacoesStore.unreadCount }}
                                    </span>
                                </div>
                            </li>
                            <li role="presentation">
                                <hr class="dropdown-divider m-0" />
                            </li>
                            <div class="notification-scroll-area">
                                <ul class="notification-list">
                                    <li v-if="notificacoesStore.loading" role="presentation">
                                        <div class="dropdown-item text-center py-4">
                                            <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                <span class="visually-hidden">Carregando...</span>
                                            </div>
                                            <p class="mb-0 mt-2 text-muted small">Carregando notificações...</p>
                                        </div>
                                    </li>
                                    <template v-else-if="notificacoesStore.notifications.length > 0">
                                        <li v-for="notification in notificacoesStore.notifications" :key="notification.id" role="presentation">
                                            <a href="javascript:;" 
                                               class="dropdown-item notification-item" 
                                               :class="{ 'notification-unread': !notification.read_at }"
                                               @click="handleNotificationItemClick(notification)">
                                                <div class="media">
                                                    <div class="media-aside align-self-start">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="feather feather-file-text"
                                                            :class="{ 'notification-icon-unread': !notification.read_at }"
                                                        >
                                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                            <polyline points="14 2 14 8 20 8"></polyline>
                                                            <line x1="16" y1="13" x2="8" y2="13"></line>
                                                            <line x1="16" y1="17" x2="8" y2="17"></line>
                                                            <polyline points="10 9 9 9 8 9"></polyline>
                                                        </svg>
                                                        <span v-if="!notification.read_at" class="notification-indicator"></span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="data-info">
                                                            <h6 :class="{ 'notification-title-unread': !notification.read_at }">
                                                                {{ notification.data?.title || 'Notificação' }}
                                                            </h6>
                                                            <p 
                                                                :class="{ 
                                                                    'notification-message-unread': !notification.read_at,
                                                                    'notification-message-expanded': expandedNotifications[notification.id]
                                                                }"
                                                            >
                                                                {{ notification.data?.message || '' }}
                                                            </p>
                                                            <div class="notification-footer-info">
                                                                <button 
                                                                    v-if="shouldShowExpandButton(notification.data?.message)"
                                                                    @click.stop="toggleNotificationExpand(notification.id)"
                                                                    class="btn-expand-notification"
                                                                    type="button"
                                                                >
                                                                    {{ expandedNotifications[notification.id] ? 'Ver menos' : 'Ver tudo' }}
                                                                </button>
                                                                <small class="text-muted">{{ formatTimeAgo(notification.created_at) }}</small>
                                                            </div>
                                                        </div>
                                                        <div class="icon-status" @click.stop="handleDeleteNotification(notification.id)" title="Remover notificação">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="18"
                                                                height="18"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                class="feather feather-x"
                                                            >
                                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </template>
                                    <li v-else role="presentation">
                                        <div class="dropdown-item text-center py-4">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="48"
                                                height="48"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-bell-off text-muted mb-2"
                                                style="opacity: 0.5;"
                                            >
                                                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                                <path d="M18.63 13A17.89 17.89 0 0 1 18 8A6 6 0 0 0 6 8c0 1.76.58 3.38 1.55 4.7"></path>
                                                <line x1="1" y1="1" x2="23" y2="23"></line>
                                            </svg>
                                            <p class="mb-0 text-muted small">Nenhuma notificação</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <template v-if="!notificacoesStore.loading && notificacoesStore.notifications.length > 0">
                                <li role="presentation">
                                    <hr class="dropdown-divider m-0" />
                                </li>
                                <li role="presentation" class="notification-footer">
                                    <a href="javascript:;" class="dropdown-item text-center py-2" @click="handleMarkAllAsRead">
                                        <small class="fw-semibold">Marcar todas como lidas</small>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                    -->

                    <template v-if="isAuthenticated">
                        <div class="dropdown nav-item user-profile-dropdown btn-group">
                            <a href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only user nav-link">
                                <ProfileAvatar :src="store.state.auth?.user?.profilePic" :name="store.state.auth?.user?.name" alt="avatar" class="avatar-img"/>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-right m-0" aria-labelledby="ddluser">
                                <li role="presentation">
                                    <router-link to="/meus-dados" class="dropdown-item">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-user"
                                        >
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="12" cy="7" r="4"></circle>
                                        </svg>
                                        Meus dados
                                    </router-link>
                                </li>
                                <li role="presentation">
                                    <router-link to="/faturas" class="dropdown-item">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-file-text"
                                        >
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                            <polyline points="14 2 14 8 20 8"></polyline>
                                            <line x1="16" y1="13" x2="8" y2="13"></line>
                                            <line x1="16" y1="17" x2="8" y2="17"></line>
                                            <polyline points="10 9 9 9 8 9"></polyline>
                                        </svg>
                                        Faturas
                                    </router-link>
                                </li>
                                <li role="presentation">
                                    <router-link to="/auth/login" @click.prevent="logout" class="dropdown-item">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-log-out"
                                        >
                                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                            <polyline points="16 17 21 12 16 7"></polyline>
                                            <line x1="21" y1="12" x2="9" y2="12"></line>
                                        </svg>
                                        Sair
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <div class="auth-links">
                            <router-link to="/auth/login" class="auth-link auth-link-login ms-2">Entrar</router-link>
                            <router-link to="/auth/register" class="auth-link auth-link-register">Cadastrar-se</router-link>
                        </div>
                    </template>
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->
    </div>
</template>

<style scoped>
    /* PLANOS - Estilos comentados temporariamente (pode ser reativado no futuro) */
    /*
    Badge do plano - usando :deep() para afetar classes do Bootstrap
    :deep(a.badge-custom),
    :deep(.badge-custom) {
        background: #9b842a !important;
        background: linear-gradient(90deg,rgba(155, 132, 42, 0.67) 0%, rgba(237, 206, 83, 0.75) 100%) !important;
        display: inline-block !important;
        padding: 0 15px !important;
        font-size: 12px !important;
        line-height: 32px !important;
        border-radius: 25px !important;
        cursor: pointer !important;
    }
    */
    
    .header :deep(.avatar-img) {
        width: 30px !important;
        height: 30px !important;
        object-fit: cover;
    }

    /* Links Entrar / Cadastrar (usuário deslogado) – degradê azul → roxo */
    .auth-links {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin-right: 1rem;
    }
    .auth-link {
        text-decoration: none;
        font-size: 0.9rem;
        font-weight: 600;
        padding: 0.4rem 0.85rem;
        border-radius: 8px;
        transition: color 0.2s, background 0.2s, border-color 0.2s, box-shadow 0.2s;
    }
    .auth-link-login {
        color: #6366f1;
        border: 1.5px solid #6366f1;
        background: transparent;
    }
    .auth-link-login:hover {
        color: #fff;
        background: linear-gradient(135deg, #4361ee 0%, #6366f1 50%, #7c3aed 100%);
        border-color: transparent;
        box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
    }
    .auth-link-register {
        color: #fff;
        background: linear-gradient(135deg, #4361ee 0%, #6366f1 50%, #7c3aed 100%);
        box-shadow: 0 2px 8px rgba(99, 102, 241, 0.35);
        border: 1.5px solid transparent;
    }
    .auth-link-register:hover {
        background: linear-gradient(135deg, #3730a3 0%, #5b21b6 100%);
        color: #fff;
        box-shadow: 0 4px 14px rgba(124, 58, 237, 0.45);
    }
    body.dark .auth-link-login {
        color: #a5b4fc;
        border-color: #818cf8;
        background: transparent;
    }
    body.dark .auth-link-login:hover {
        color: #fff;
        background: linear-gradient(135deg, #4361ee 0%, #7c3aed 100%);
        border-color: transparent;
    }

    /* Barra única: nav Início / Meus cursos */
    .header-nav-toggle {
        display: flex;
        align-items: center;
        padding: 0 12px;
        color: #64748b;
    }
    .header-nav-toggle:hover {
        color: #4361ee;
    }
    .header-nav-toggle svg {
        width: 20px;
        height: 20px;
    }
    .header-nav-links {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-right: 12px;
    }
    @media (max-width: 767px) {
        .header-nav-links {
            display: none;
        }
    }
    .header-nav-link {
        color: #475569;
        text-decoration: none;
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0.4rem 0.75rem;
        border-radius: 8px;
        transition: color 0.2s, background 0.2s;
    }
    .header-nav-link:hover,
    .header-nav-link.router-link-active {
        color: #4361ee;
        background: rgba(67, 97, 238, 0.08);
    }
    body.dark .header-nav-toggle {
        color: #94a3b8;
    }
    body.dark .header-nav-toggle:hover {
        color: #fff;
    }
    body.dark .header-nav-link {
        color: #e2e8f0;
    }
    body.dark .header-nav-link:hover,
    body.dark .header-nav-link.router-link-active {
        color: #fff;
        background: rgba(255, 255, 255, 0.1);
    }

    /* NOTIFICAÇÕES - Estilos removidos temporariamente (pode ser reativado no futuro) */
    
</style>

<!-- 
    NOTIFICAÇÕES - ESTILOS MODO ESCURO COMENTADOS
    (pode ser reativado no futuro)
    
    Todo o bloco de estilos do modo escuro para notificações foi removido.
    Para reativar, descomente o código HTML das notificações e adicione
    os estilos do modo escuro novamente.
-->

<script setup>
    import ProfileAvatar from '@/views/components/ProfileAvatar.vue';

    import { onMounted, computed } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter, useRoute } from 'vue-router';
    // import { useNotificacoesStore } from '@/stores/notificacoes'; // COMENTADO - Notificações desativadas temporariamente

    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    // const notificacoesStore = useNotificacoesStore(); // COMENTADO - Notificações desativadas temporariamente
    const isHorizontal = computed(() => store.state.menu_style === 'horizontal');
    const isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);
    
    /* ============================================
       CÓDIGO DE NOTIFICAÇÕES - COMENTADO
       (pode ser reativado no futuro)
       ============================================ */
    /*
    // Estado para controlar quais notificações estão expandidas
    const expandedNotifications = ref({});
    
    // Função para verificar se o texto precisa de botão "Ver tudo"
    const shouldShowExpandButton = (message) => {
        if (!message) return false;
        return message.length > 100;
    };
    
    // Função para alternar o estado expandido de uma notificação
    const toggleNotificationExpand = (notificationId) => {
        expandedNotifications.value[notificationId] = !expandedNotifications.value[notificationId];
    };

    // Função para iniciar o polling apenas como fallback se o WebSocket não estiver disponível
    const iniciarPollingSeAutenticado = () => {
        if (store.state.auth?.user && !notificacoesStore.isPolling && !notificacoesStore.isListening) {
            notificacoesStore.startPolling(30000);
        }
    };

    // Função para iniciar o listener de WebSocket se o usuário estiver autenticado
    const iniciarListenerSeAutenticado = () => {
        const user = store.state.auth?.user;
        if (user && !notificacoesStore.isListening) {
            const userId = user.id || user.uuid;
            if (userId) {
                notificacoesStore.startListening(userId);
            }
        }
    };
    */

    onMounted(() => {
        toggleMode();
        
        /* CÓDIGO DE NOTIFICAÇÕES COMENTADO
        iniciarPollingSeAutenticado();
        iniciarListenerSeAutenticado();
        
        const unlockAudioOnInteraction = () => {
            notificacoesStore.unlockAudioContext();
            document.removeEventListener('click', unlockAudioOnInteraction);
            document.removeEventListener('touchstart', unlockAudioOnInteraction);
            document.removeEventListener('keydown', unlockAudioOnInteraction);
        };
        
        document.addEventListener('click', unlockAudioOnInteraction, { once: true });
        document.addEventListener('touchstart', unlockAudioOnInteraction, { once: true });
        document.addEventListener('keydown', unlockAudioOnInteraction, { once: true });
        */
    });

    /* WATCH DE NOTIFICAÇÕES COMENTADO
    watch(
        () => store.state.auth?.user,
        (newUser, oldUser) => {
            if (newUser) {
                iniciarPollingSeAutenticado();
                iniciarListenerSeAutenticado();
            } else {
                notificacoesStore.stopPolling();
                notificacoesStore.stopListening();
            }
        },
        { immediate: true }
    );

    onUnmounted(() => {
        notificacoesStore.stopPolling();
        notificacoesStore.stopListening();
    });
    */

    const toggleMode = (mode) => {
        window.$appSetting.toggleMode(mode);
    };

    const logout = async () => {
        try {
            // Para o polling e o listener antes de fazer logout
            await store.dispatch('auth/LogOut');
            router.push({ name: 'login' });
        } catch (error) {
            console.log(error);
            router.push({ name: 'login' });
        }
    };

    /* ============================================
       HANDLERS DE NOTIFICAÇÕES - COMENTADOS
       (pode ser reativado no futuro)
       ============================================ */
    /*
    const formatTimeAgo = (dateString) => {
        if (!dateString) return '';
        
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        
        if (diffInSeconds < 60) {
            return 'agora';
        }
        
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `há ${diffInMinutes} ${diffInMinutes === 1 ? 'minuto' : 'minutos'}`;
        }
        
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `há ${diffInHours} ${diffInHours === 1 ? 'hora' : 'horas'}`;
        }
        
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 30) {
            return `há ${diffInDays} ${diffInDays === 1 ? 'dia' : 'dias'}`;
        }
        
        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) {
            return `há ${diffInMonths} ${diffInMonths === 1 ? 'mês' : 'meses'}`;
        }
        
        const diffInYears = Math.floor(diffInMonths / 12);
        return `há ${diffInYears} ${diffInYears === 1 ? 'ano' : 'anos'}`;
    };

    const handleNotificationClick = async () => {
        try {
            await notificacoesStore.fetchNotifications();
        } catch (error) {
            console.error('Erro ao carregar notificações:', error);
        }
    };

    const handleNotificationItemClick = async (notification) => {
        if (!notification.read_at) {
            await handleMarkAsRead(notification.id);
        }
        
        if (notification.data?.action_url) {
            try {
                const url = new URL(notification.data.action_url);
                window.open(url.href, '_blank', 'noopener,noreferrer');
            } catch (e) {
                const fullUrl = window.location.origin + notification.data.action_url;
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
            }
        }
    };

    const handleMarkAsRead = async (notificationId) => {
        try {
            await notificacoesStore.markAsRead(notificationId);
        } catch (error) {
            console.error('Erro ao marcar notificação como lida:', error);
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            await notificacoesStore.markAllAsRead();
        } catch (error) {
            console.error('Erro ao marcar todas as notificações como lidas:', error);
        }
    };

    const handleDeleteNotification = async (notificationId) => {
        if (!confirm('Tem certeza que deseja remover esta notificação?')) {
            return;
        }

        try {
            await notificacoesStore.deleteNotification(notificationId);
        } catch (error) {
            console.error('Erro ao remover notificação:', error);
            alert('Erro ao remover notificação. Tente novamente.');
        }
    };
    */
</script>
